module.exports = __webpack_public_path__ + "static/media/home_introduce_3.b56807b0.jpg";